import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { Map, List } from 'immutable';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as adminLib from 'libs/adminLib';

import { ExamTemplateAttachFile } from 'components';

class CtExamTemplateAttachFile extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      onProgress: false,
      attachFileVisible: false,
      attachFile: { accept: [], reject: [] },
      // isUpload - 0: 초기값, 1: 성공, 2: 실패
      uploadResult: { isUpload: 0, message: '' }
    };
  }

  uploadAttachFile = async () => {
    if (!this.state.onProgress) {
      this.setState({ onProgress: true });
    }

    const stateObj = { onProgress: false };

    const { isAuth, templateNo, serviceTemplateNo } = this.props;

    const attachFile = this.state.attachFile['accept'];
    if (!!attachFile.length > 0) {
      const formData = new FormData();
      formData.append('examTemplateNo', templateNo);
      attachFile.map(file => {
        formData.append('file', file);
      });

      try {
        const respObj = await adminLib.uploadExamTemplateAttachFile(formData);

        if (respObj && respObj.status && respObj.status === 200) {
          // 파일 확장자 exe만 가능
          if (!!respObj.data.error && !!respObj.data.error[0].errInfo) {
            stateObj.uploadResult = {
              isUpload: 2,
              message: respObj.data.error[0].errInfo
            };
          } else {
            // 국제화 처리
            const { formatMessage } = this.props.intl;
            // 업로드 정상 응답
            if (!!respObj.data.list[0].isOk) {
              // 파일 리턴
              stateObj.uploadResult = {
                isUpload: 1,
                message: attachFile[0].name + ' (' + attachFile[0].size + ')'
              };
              stateObj.attachFile = { accept: [], reject: [] };
            } else {
              // 파일 없음
              stateObj.uploadResult = {
                isUpload: 2,
                message: defineMessages(
                  formatMessage({ id: 'CtExamTemplateAttachFile_1', defaultMessage: '업로드된 파일이 없습니다.' })
                )
              };
            }
          }
        } else {
          // 업로드 에러
          stateObj.uploadResult = { isUpload: 3, message: respObj.error.map(e => e) };
        }
      } catch (e) {
        console.log(e);
      }
    }

    this.setState(stateObj);
  };

  resetAttachFile = () => {
    this.setState({
      onProgress: false,
      attachFile: { accept: [], reject: [] },
      uploadResult: { isUpload: 0, message: '' }
    });
  };

  handleOnDropAttachFile = files => {
    const { coreFileRef } = this.props;

    if (true) {
      this.setState({
        uploadResult: { isUpload: 0, message: '' },
        attachFile: { accept: files, reject: [] }
      });

      // 업로드 대상이 되면 파일명을 첨부파일(원본)에 갱신해 준다.
      if (coreFileRef && typeof coreFileRef.props.onChange === 'function') {
        coreFileRef.props.onChange(files[0].name);
      }
    } else {
      this.setState({
        uploadResult: { isUpload: 0, message: '' },
        attachFile: { accept: [], reject: files }
      });
    }
  };

  handleOnToggleAttachFileModal = () => {
    this.setState({ attachFileVisible: !this.state.attachFileVisible });
  };

  render() {
    const { onProgress, attachFileVisible, attachFile, uploadResult } = this.state;
    const { isAuth } = this.props;
    const { handleOnDropAttachFile, handleOnToggleAttachFileModal, resetAttachFile, uploadAttachFile } = this;

    return (
      <ExamTemplateAttachFile
        onProgress={onProgress}
        isAuth={isAuth}
        attachFileVisible={attachFileVisible}
        attachFile={attachFile}
        uploadResult={uploadResult}
        resetAttachFile={resetAttachFile}
        uploadAttachFile={uploadAttachFile}
        handleOnDropAttachFile={handleOnDropAttachFile}
        handleOnToggleAttachFileModal={handleOnToggleAttachFileModal}
      />
    );
  }
}

CtExamTemplateAttachFile.propTypes = {};
CtExamTemplateAttachFile.defaultProps = {};

const mapStateToProps = state => {
  return {
    isAuth: state.user.get('isAuth')
  };
};

// const mapDispatchToProps = dispatch => ({
//   AdminActions: bindActionCreators(adminActions, dispatch)
// });

export default connect(mapStateToProps)(injectIntl(CtExamTemplateAttachFile));



// WEBPACK FOOTER //
// ./src/script/containers/examTemplate/CtExamTemplateAttachFile.js